export default __webpack_public_path__ + "static/images/3c63fe8f42b9766530b35497b62adc4d.jpg";